import React from "react";
import "./merchant-row.css";

/** Placeholder row shown while the merchants list is loading. Mirrors
 * MerchantRow's grid so the skeletons line up with the real rows once they
 * arrive — matches CardRowSkeleton's treatment. */
function MerchantRowSkeleton() {
  return (
    <div className="mr-row mr-row--skeleton" aria-hidden="true">
      <div className="mr-id">
        <span className="mr-skeleton-bar mr-skeleton-bar--logo" />
        <span className="mr-skeleton-bar mr-skeleton-bar--name" />
      </div>
      <div className="mr-total">
        <span className="mr-skeleton-bar mr-skeleton-bar--bal" />
      </div>
      <span className="mr-skeleton-bar mr-skeleton-bar--status" />
      <div className="mr-actions">
        <span className="mr-skeleton-bar mr-skeleton-bar--btn" />
      </div>
    </div>
  );
}

export default MerchantRowSkeleton;
